var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudience({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    fill: "#FF00FF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,33.333c-7.2,0-12.122,5.808-10.938,12.91l1.797,10.752c0.71,4.265,4.817,7.748,9.141,7.748 c4.319,0,8.435-3.483,9.144-7.748l1.791-10.752C62.119,39.141,57.197,33.333,50,33.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.451,69.704L59.922,65.53c-2.63,2.568-6.165,4.213-9.922,4.213s-7.292-1.645-9.922-4.213l-12.526,4.174 c-2.317,0.774-4.219,3.408-4.219,5.853v11.11h53.334v-11.11C76.667,73.112,74.769,70.479,72.451,69.704z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.333,26.667c-2.984,0-5.54,1.038-7.467,2.715c2.552,0.931,4.82,2.457,6.559,4.512c2.995,3.535,4.248,8.333,3.441,13.17 l-1.791,10.752c-0.01,0.065-0.039,0.127-0.052,0.192c4.06-0.349,7.783-3.646,8.454-7.679l1.79-10.752 C75.452,32.474,70.53,26.667,63.333,26.667z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.571,33.894c2.416-2.852,5.834-4.697,9.643-5.313l0.387-2.338c1.186-7.103-3.736-12.91-10.934-12.91 c-7.201,0-12.123,5.808-10.938,12.91l1.797,10.752c0.553,3.337,3.196,6.169,6.39,7.256C33.903,40.403,35.163,36.738,37.571,33.894z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.964,64.961l11.094-3.691c-0.512-1.097-0.932-2.239-1.133-3.454l-1.384-8.301c-2.946-0.491-5.671-1.91-7.796-3.984 l-12.526,4.174C11.901,50.479,10,53.112,10,55.557v11.11h12.845C23.789,65.928,24.837,65.339,25.964,64.961z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.784,63.037l-12.529-4.173c-1.797,1.754-4.033,3.027-6.455,3.688l7.23,2.409c4.355,1.455,7.637,6.009,7.637,10.596V80H90 V68.89C90,66.445,88.103,63.812,85.784,63.037z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/audience.0e9ee4e814dc5e02d09ed1c055bafd7f.svg";
export { ForwardRef as ReactComponent };